module.exports = __webpack_public_path__ + "asset/image-collaborator-screenshot-fea6a8aecbf8609d.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/collaborator-screenshot.png
// module id = M3T8
// module chunks = 1